import {authenticated_api} from "./base";

export const saveSearchApi = async (searchSpec, config = {}) => {
  try {
    return await authenticated_api.post("/save-search/", searchSpec, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error; 
  }
};

export const getSavedSearches = async () => {
  try {
    return await authenticated_api.get(`/all-saved-searches/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const deleteSavedSearch = async (searchId) => {
  try {
    if (searchId) {
      return await authenticated_api.delete(`/search/?search_id=${searchId}`);
    }
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log("Delete failed", error);
    return error.response;
  }
};

export const searchApi = async (searchSpec, config = {}) => {
  try {
    return await authenticated_api.post("/search/", searchSpec, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error; 
  }
};

export const exportCompaniesApi = async (exportSpec) => {
  try {
    return await authenticated_api.post("/export/companies", exportSpec, {
      responseType: 'blob',
      timeout: 60000
    });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

export const getLocationApi = async () => {
  try {
    return await authenticated_api.get(`/extent/locations/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getOperationModel = async () => {
  try {
    return await authenticated_api.get(`/extent/industry/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getRecentView = async () => {
  try {
    return await authenticated_api.get(`/company/viewed/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};
